/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Profile_Editors_Same_ChangeInputs */

const en_us2_profile_editors_same_change = /** @type {(inputs: Profile_Editors_Same_ChangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} · change`)
};

const pt_br2_profile_editors_same_change = /** @type {(inputs: Profile_Editors_Same_ChangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} · mudar`)
};

const es_419_profile_editors_same_change = /** @type {(inputs: Profile_Editors_Same_ChangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} · cambiar`)
};

const pt_pt2_profile_editors_same_change = /** @type {(inputs: Profile_Editors_Same_ChangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} · mudar`)
};

const fr_fr2_profile_editors_same_change = /** @type {(inputs: Profile_Editors_Same_ChangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} · changer`)
};

const de_de2_profile_editors_same_change = /** @type {(inputs: Profile_Editors_Same_ChangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} · ändern`)
};

const it_it2_profile_editors_same_change = /** @type {(inputs: Profile_Editors_Same_ChangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} · cambia`)
};

/**
* | output |
* | --- |
* | "{label} · change" |
*
* @param {Profile_Editors_Same_ChangeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_same_change = /** @type {((inputs: Profile_Editors_Same_ChangeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Same_ChangeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_same_change(inputs)
	if (locale === "es-419") return es_419_profile_editors_same_change(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_same_change(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_same_change(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_same_change(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_same_change(inputs)
	return en_us2_profile_editors_same_change(inputs)
});
export { profile_editors_same_change as "profile-editors.same_change" }